module.exports = __webpack_public_path__ + "img/page-20.4c9c419f.jpg";